import { h5LegalUrl } from "./legalLinks";

type Props = {
  linkClassName?: string;
};

/** 与 Web 登录框一致的协议文案（H5 外链打开） */
export function LoginLegalAgreeText(props: Props) {
  const linkClass = props.linkClassName ?? "login-page-agree-link";
  return (
    <span>
      我已阅读并同意
      <a
        className={linkClass}
        href={h5LegalUrl("user-agreement")}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        《用户协议》
      </a>
      与
      <a
        className={linkClass}
        href={h5LegalUrl("privacy")}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        《隐私政策》
      </a>
    </span>
  );
}
